import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import LoggedSidebar from 'App/Shell/LoggedSidebar'
import { Totalizers } from './Totalizers'
import { Infos } from './Infos'
import { Details } from './Details'
import ReactPlaceholder from 'react-placeholder'
import ExtractPlaceholder from './ExtractPlaceholder'
import Helmet from 'react-helmet'

class Extract extends Component {
  componentDidMount () {
    this.props.fetchCampaignName()
    this.props.loadBalance(false)
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Seu extrato - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <ReactPlaceholder
          ready={
            !this.props.totalizers.isLoading || !this.props.balance.isLoading
          }
          customPlaceholder={<ExtractPlaceholder />}
        >
          <div className='container-fluid bg-ui-4 mt-sm-0 pb-5'>
            <div className='container pl-2 pr-2 px-0 px-md-1 py-0 py-sm-2 pt-md-3'>
              <div className='row mx mx-md-0'>
                <div className='col-12 px-0'>
                  <div className='row'>
                    <LoggedSidebar selected='/extract' />
                    <div className='col-12 col-lg-8 px-0 px-md-0'>
                      <div className='row mx-0'>
                        <div className='box-totalizers col-12 mb-2 border-color-ui-3 bg-white border radius'>
                          <div className='row px-3 py-2 border-bottom border-color-ui-3'>
                            <div className='col mx-0 px-0'>
                              <h2 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                                Extrato
                              </h2>
                            </div>
                          </div>
                          <Totalizers {...this.props} />
                          <Infos {...this.props} />
                        </div>
                        <div className='col-12 border-color-ui-3 bg-white border radius'>
                          <Details {...this.props} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ReactPlaceholder>
      </Fragment>
    )
  }
}

Extract.propTypes = {
  fetchCampaignName: PropTypes.func.isRequired,
  totalizers: PropTypes.shape({ isLoading: PropTypes.bool.isRequired })
    .isRequired,
  balance: PropTypes.shape({ isLoading: PropTypes.bool.isRequired }).isRequired,
  loadBalance: PropTypes.func
}

export default Extract



// WEBPACK FOOTER //
// ./src/Participant/Extract/Extract.js